const vpt = [
    {
        path: "voucher-package-tour",
        name: "voucher-package-tour",
        component: () => import("@/views/voucher-package-tour/VPTIndex.vue"),
        meta: {
            title: "Voucher Package Tour",
            requiresAuth: true,
            roles: ["Super Admin", "Admin Office"],
        },
    },
];

export default vpt;
